import styled from 'styled-components';

export const S_Footer = styled.div`
  height: 100px;
`;
